import * as React from 'react';
import { connect } from 'react-redux';
import * as actions from 'modules/actions/bidProjectDetail';
import * as moveActions from 'modules/actions/bidProjectMove';

import { Spin } from '@beehive/components';
import { Dispatch, bindActionCreators } from 'redux';
// import HeaderForm from './HeaderForm';
// import BaseInfo from './BaseInfo';
import { isBlank } from 'utils/object';
import { ExtraContextProvider, OptionsContextProvider } from '../Drawer/components/DetailLayout/context';
import { getNodeBaseInfoMapComp } from '../Drawer/utils';
import _ from 'lodash';

const ProjectDetailDrawer = (props: any) => {
  const {
    prefixCls = '',
    location,
    history,
    projectDetail,
    loadDetail,
    projectMove,
    refreshList,
    match,
  } = props;

  const projectId = _.get(match, 'params.id');
  const hasProjectId = !!projectId;

  const { detail = {} } = projectDetail;

  const getDetail = (params: any = {}) => {
    // const menuKey = this.getMenuKey();
    const newParams = { ...params };
    projectId && loadDetail(projectId, newParams);
  };

  React.useEffect(() => {
    if (hasProjectId) {
      getDetail();
    }
  }, [projectId]);

  const mapComponent = getNodeBaseInfoMapComp({
    detail,
    getDetail,
    projectMove,
    history,
    location,
    projectId,
    refreshList,
  });

  return (
    <div className={prefixCls}>
      <Spin.Global spinning={projectDetail.detailLoading} />
      {!isBlank(detail) && (
        <OptionsContextProvider productId={detail.product_id}>
          <ExtraContextProvider showBack={false}>{mapComponent}</ExtraContextProvider>
        </OptionsContextProvider>
      )}
    </div>
  );
};

const mapStateToProps = (state: any) => {
  const projectDetail = state.bidProjectDetail;
  return {
    projectDetail,
  };
};

export function mapDispatchToProps(dispatch: Dispatch<any>, ownProps: any) {
  return bindActionCreators(
    {
      loadDetail: actions.loadDetail,
      projectMove: moveActions.projectMove,
      refreshList: moveActions.refreshList,
      projectDelete: moveActions.projectDelete,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectDetailDrawer);
